import React from 'react';
import './ReportStatusInfo.css';
import { ReactComponent as CloseForm } from '../images/close-message.svg';

function ReportStatusInfo(props) {
  return (
    <div className="report-status-info">
      <div className="info-bg-shadow" onClick={props.closeMessage}></div>
      <div className="status-message-container">
        <div className="sm-header">
          <div className="sm-title">Status prijave</div>
          <button
            style={{ fontWeight: 'bolder' }}
            className="sm-close-button"
            onClick={props.closeMessage}
          >
            <CloseForm style={{ height: '10px' }} />
          </button>
        </div>

        <div className="sm-body">
          {props.showErrorMessage === null ? (
            <>
              {props.reportStatusDetails.status === 1 && (
                <div className="status-message">
                  Kvar koji ste prijavili je u razmatranju i bit će obrađen u
                  što kraćem periodu.
                </div>
              )}
              {props.reportStatusDetails.status === 2 && (
                <div className="status-message">
                  Kvar koji ste prijavili je odbijen.
                  {props.reportStatusDetails.statusComment && (
                    <div className="reject-reason">
                      <b>Razlog: </b>
                      {props.reportStatusDetails.statusComment}
                    </div>
                  )}
                </div>
              )}
              {props.reportStatusDetails.status === 3 && (
                <div className="status-message">
                  Kvar koji ste prijavili je prihvaćen. Hvala na Vašem
                  doprinosu.
                </div>
              )}
              {props.reportStatusDetails.status === 4 && (
                <div className="status-message">
                  Kvar koji ste prijavili je u fazi popravke. Hvala na Vašem
                  doprinosu.
                </div>
              )}
              {props.reportStatusDetails.status === 5 && (
                <div className="status-message">
                  Kvar koji ste prijavili je popravljen. Hvala na Vašem
                  doprinosu.
                </div>
              )}
            </>
          ) : (
            <>
              <div className="status-message">
                {props.showErrorMessage === 404
                  ? ' Kod koji ste unijeli je pogrešan. Provjerite da li je ispravno napisan i pokušajte ponovo.'
                  : props.showErrorMessage === 429
                  ? 'Izvršili ste veliki broj provjera u kratkom periodu. Pokušajte kasnije.'
                  : 'Trenutno nije moguće izvršiti provjeru statusa prijave. Pokušajte kasnije.'}
              </div>
            </>
          )}
          <button
            className="sm-button sm-close-info"
            onClick={props.closeMessage}
          >
            Zatvori
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReportStatusInfo;
